export default "__VITE_ASSET__DY2Gmz7___"